var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubmitted({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.6289,
    cy: 20.9219,
    r: 20,
    fill: "#53B7E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6994 29.6238V31.8094C16.599 31.991 11.8372 30.2678 9.36209 25.6242C8.21985 23.4519 7.78636 20.9766 8.12243 18.5454C8.45851 16.1143 9.54728 13.8494 11.236 12.0684C12.9274 10.276 15.1447 9.06755 17.5677 8.61743C19.9907 8.16731 22.4941 8.49885 24.7164 9.56419C29.6101 11.9348 31.9276 16.4825 31.3967 22.4605H29.0774C29.0774 22.2601 29.0774 22.0631 29.0774 21.8679C29.0586 20.5918 29.1699 19.2985 28.8393 18.0481C27.8664 14.3414 25.5403 11.9468 21.8165 11.039C17.291 9.93075 12.8375 12.4298 11.0801 16.5082C8.93215 21.4927 11.7207 27.5683 16.9262 29.0722C17.8152 29.3292 18.747 29.4388 19.6994 29.6238Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.582 29.78L24.2452 28.1305L26.6433 30.5954L31.597 25.5938L33.2413 27.3066C33.1882 27.3666 33.1111 27.4642 33.0221 27.5533C31.2441 29.3324 29.4661 31.111 27.6881 32.8889C26.9773 33.5981 26.3932 33.6015 25.6892 32.8889C24.6495 31.8663 23.62 30.8249 22.582 29.78Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.55 16.6641V18.9576H13.9023V16.6641H25.55Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8945 21.3203H19.6927V23.6241H13.8945V21.3203Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmitted);
export default __webpack_public_path__ + "static/media/submitted.5f8877f3c5bfbae604f13d9c90b3b689.svg";
export { ForwardRef as ReactComponent };